import axios from 'axios';
import { API_BASE_URL, API_ROUTES, AES_KEY, DEFAULT_PAGE_SIZE, getAuthToken } from '../config/appConfig';
import { decryptAES } from '../utils/crypto';

/**
 * 通用酒店查询接口 (自动路由展会/非展会)
 * @param {Object} params - 查询参数
 * @param {Number|String} [params.ExhibitionId] - 展会ID (如果有值，走展会查询接口)
 * @param {String} [params.keyword] - 搜索关键字
 * @param {Array} [params.dateRange] - [开始日期, 结束日期]
 * @param {Array} [params.priceRange] - [最低价, 最高价]
 * @param {Array} [params.stockTypes] - 合作类型
 */
export function searchHotels(params) {
  // 1. 动态决定接口地址
  // 如果传了 ExhibitionId，且不为0，则使用展会查询接口，否则使用普通查询接口
  const isExhibitionMode = params.ExhibitionId && params.ExhibitionId != 0;
  const apiPath = isExhibitionMode ? API_ROUTES.EXHIBITION_SEARCH : API_ROUTES.NORMAL_SEARCH;
  const url = `${API_BASE_URL}${apiPath}`;
  
  // 2. 构造通用参数
  const formData = new URLSearchParams();
  
  // 分页 (地图模式通常一次性拉取大量数据)
  formData.append('PageIndex', 1);
  formData.append('PageSize', DEFAULT_PAGE_SIZE);

  // 基础筛选
  if (params.keyword) formData.append('SearchInput', params.keyword);
  
  if (params.dateRange && params.dateRange.length === 2) {
    formData.append('StartTime', params.dateRange[0]);
    formData.append('EndTime', params.dateRange[1]);
  }

  if (params.priceRange) {
    formData.append('MinPrice', params.priceRange[0]);
    formData.append('MaxPrice', params.priceRange[1]);
  }

  // 合作类型 (假设后端只收单个值，取数组第一个)
  if (params.stockTypes && params.stockTypes.length > 0) {
     formData.append('StockType', params.stockTypes[0]); 
  }

  // ★★★ 3. 展会模式特有参数 ★★★
  if (isExhibitionMode) {
      formData.append('ExhibitionId', params.ExhibitionId);
  } else {
      // 这里预留给非展会接口的参数 (比如 CityId 等)
      // if (params.CityId) formData.append('CityId', params.CityId);
  }

  // 4. 发起请求 (自动携带 Token)
  return axios.post(url, formData, {
    headers: { 
        'Content-Type': 'application/x-www-form-urlencoded',
        'Authorization': getAuthToken() // ★ 动态获取 Token
    }
  }).then(res => {
    if (res.data && res.data.Success) {
      // 解密数据
      if (res.data.JsonDatas) {
        const jsonStr = decryptAES(res.data.JsonDatas, AES_KEY);
        try {
          const list = JSON.parse(jsonStr);
          return list || [];
        } catch (e) {
          console.error("JSON解析失败", e);
          return [];
        }
      }
      return []; // Datas 为空的情况
    } else {
      throw new Error(res.data.Message || '查询失败');
    }
  });
}